module.exports = __webpack_public_path__ + "static/img/IMG_20160918_162512.41284c0c.jpg";